export default {
  'result-fail.error.title': '提交失敗',
  'result-fail.error.description': '請核對並修改以下信息後，再重新提交。',
  'result-fail.error.hint-title': '您提交的內容有如下錯誤：',
  'result-fail.error.hint-text1': '您的賬戶已被凍結',
  'result-fail.error.hint-btn1': '立即解凍',
  'result-fail.error.hint-text2': '您的賬戶還不具備申請資格',
  'result-fail.error.hint-btn2': '立即升級',
  'result-fail.error.btn-text': '返回修改',
};
